<template minapp='mpx' xlang='wxml'>
<view class="total-fee-wrap" wx:style="{{customStyle}}">
  <view class="total-fee-title">
    <view>
      <text class="total-fee-left">总计</text>
      <text class="total-fee-price-left">¥</text>
      <text class="total-fee-price-right">{{personalPay}}</text>
    </view>
    <view class="total-fee-right" bind:tap="click">查看明细
       <es-icon name="angle-right" size="16" color="#666666"/>
    </view>
  </view>
  <text wx:if="{{orderId}}" class="order-text">订单号：{{orderId}}</text>
</view>

 
</template>

<style lang="stylus" scoped>
  .total-fee-wrap
    background-color #ffffff
    padding 17px 12px
    border-radius 8px
  .total-fee
    &-title
      color #000000
      display flex
      justify-content space-between
    &-left
      font-family PingFangSC-Semibold
      font-size 16px
      font-weight 600
      margin-right 5px
    &-right
      font-size 12px
      display flex
      align-items center
      color #666666
    &-price-left
      font-family PingFangSC-Medium
      font-size 16px
      line-height 12px
      font-weight 600
      margin-right 2px
      color #FF6400
    &-price-right
      font-family Barlow Semi Condensed
      font-size 20px
      line-height 12px
      font-weight 400
      color #FF6400
  .order-text
    font-size 13px
    margin-top 4px
    color #999999
</style>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'

  createComponent({
    props: {
      customStyle: {
        type: Object,
        value: {}
      }
    },
    computed: {
      ...store.mapState({
        orderId: 'order.base_info.order_number', // 展示12306的订单ID
        feeInfo: 'order.fee_info'
      }),
      personalPay() {
        return getFinalPrice(this.feeInfo?.personal_pay)
      }
    },
    methods: {
      click() {
        this.triggerEvent('click')
      }
    }
  })
</script>